import {
    IS_LOADED,
    IS_LOADING,
    SECTION,
    GET_USER,
    EMPLOYEES,
    MODULES,
    SPRINT,
    CALENDARDASHSTORY,
    EVENTS,
    ALLPROJETS,
    ACTIVE_SPRINT,
    IS_FETCH,
    IS_FETCHED
  } from "./action";
  
  export const initialState = {
    fetching:false,
    isLoading: false,
    employees: [],
    user:[],
    section: [],
    modules: [],
    sprint: {},
    calendarDashStory: [],
    events: [],
    allProjects: [],
    activeSprint:[],
  };
  
  export function reducer(state, action) {
    switch (action.type) {
      case IS_FETCH:
        return { ...state, fetching: true };
      case IS_FETCHED:
        return { ...state, fetching: false };
      case IS_LOADING:
        return { ...state, isLoading: true };
      case IS_LOADED:
        return {
          ...state,
          isLoading: false,
        };
        case EVENTS : 
        return {
          ...state,
          events: action.payLoad,
        }
        case ALLPROJETS :
          return {
            ...state,
            allProjects: action.payLoad,
          }
        case CALENDARDASHSTORY :
          return {
                ...state,
                calendarDashStory: action.payLoad,
        };
        case SPRINT :
          return {
                ...state,
                sprint: action.payLoad,
        };
        case SECTION :
        return {
              ...state,
              section: action.payLoad,
      };
        case EMPLOYEES:
            return {
                ...state,
                employees: action.payload
            };
            case MODULES:
            return {
                ...state,
                modules: action.payLoad
            };
      case GET_USER :
        return {...state, user : state.user.concat(action.payLoad)};
      case ACTIVE_SPRINT:
          return {
              ...state,
              activeSprint: action.payload
          };
      default:
        return state;
    }
  }
  